import { render, staticRenderFns } from "./HoldBalanceDialog.vue?vue&type=template&id=2d3a5b54"
import script from "./HoldBalanceDialog.vue?vue&type=script&lang=js"
export * from "./HoldBalanceDialog.vue?vue&type=script&lang=js"
import style0 from "./HoldBalanceDialog.vue?vue&type=style&index=0&id=2d3a5b54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports